import React from 'react';
import SectionHeading from '../common/SectionHeading';
import NewsCard from '../common/NewsCard';

function VividhSection({ items, onOpen, onViewAll }) {
  if (!items || items.length === 0) return null;

  return (
    <section className="mt-12">
      <SectionHeading title="विविध समाचार" onViewAll={onViewAll} />
      <div className="grid gap-7 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 w-full">
        {items.map((item) => (
          <NewsCard key={item.id} item={item} onOpen={onOpen} />
        ))}
      </div>
    </section>
  );
}

export default VividhSection;